import { render } from "./DescriptionList.vue?vue&type=template&id=193c1ead&scoped=true&ts=true"
import script from "./DescriptionList.vue?vue&type=script&lang=ts"
export * from "./DescriptionList.vue?vue&type=script&lang=ts"

import "./DescriptionList.vue?vue&type=style&index=0&id=193c1ead&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193c1ead"]])

export default __exports__